<template>
    <div>
        <el-skeleton v-if="dataLoading" :rows="13" animated />
        <div v-else id="pie-chart"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import { platformStatistic } from "@/api/statistic"

export default {
    data: () => ({
        pieData: [],
        dataLoading: false
    }),
    props: {
        time: {
            type: Object,
            required: true,
        }
    },
    methods: {
        async getData() {
            this.dataLoading = true
            try {
                const { data } = await platformStatistic(this.time)
                console.log('platformStatistic', data);
                this.pieData = data
                return Promise.resolve('yayy')
            } catch {
                return Promise.reject('noo')
            } finally {
                this.dataLoading = false
            }
        },
        initChart() {
            const pieChart = echarts.init(document.querySelector("#pie-chart"))
            pieChart.setOption({
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    top: '5%',
                    left: 'center'
                },
                series: [
                    {
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                            borderRadius: 10,
                            borderColor: '#fff',
                            borderWidth: 2
                        },
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 40,
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: [
                            ...this.pieData.map(({ user_count, name }) => ({ value: user_count, name })),
                        ]
                    }
                ]
            })
        }
    },
    watch: {
        time: {
            handler() {
                this.getData().then(() => {
                    this.initChart()
                })
            },
            deep: true
        }
    },
    mounted() {
        this.getData().then(() => {
            this.initChart()
        })
    }
}
</script>

<style lang="scss" scoped>
#pie-chart {
    min-height: 500px;
}
</style>